/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DashboardStat { 
    level1?: string | null;
    schools?: number | null;
    devices?: number | null;
    synched?: number | null;
    openbook?: number | null;
    duration?: number | null;
}

